export enum FlowVariableType {
	RecordVariable,
	FlowVariable,
}
